import { render, staticRenderFns } from "./IOSUpload.vue?vue&type=template&id=0f71c6b6&scoped=true&"
import script from "./IOSUpload.vue?vue&type=script&lang=ts&"
export * from "./IOSUpload.vue?vue&type=script&lang=ts&"
import style0 from "./IOSUpload.vue?vue&type=style&index=0&id=0f71c6b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f71c6b6",
  null
  
)

export default component.exports